var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"content__inner"},[_c('keep-alive',[_c(_vm.viewComponent,{tag:"component",attrs:{"current-user":_vm.currentUser}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }